<template>
    <div id="orderRequirements" :class="{readonly: !$store.getters.loggedUserCanModifyInventory}">
        <Panel :title="$t('inventory.required_items')">

            <TipBox info no-border>
                <span v-html="$t('inventory.required_items_description')"></span>
            </TipBox>

            <Panel v-for="categorySelect in categorySelections" v-if="ready" :title="getCategoryName(categorySelect.catId)"
                   :key="categorySelect.catId" collapsible>
                <div v-for="select in categorySelect.items" class="item-checkbox-line">
                    <input :id="`chk_${select.itemId}`" type="checkbox" :value="select.itemId" v-model="data.items">
                    <label :for="`chk_${select.itemId}`">{{getItemName(select.itemId)}}</label>
                </div>
            </Panel>
        </Panel>

        <div class="footer-actions" v-if="$store.getters.loggedUserCanModifyInventory">
            <button class="btn btn-primary" @click="save">{{$t('save')}}</button>
        </div>

    </div>
</template>

<script>
  import {Core} from "@/core/Core";

  export default {
    name: "orderRequirements",

    data() {
      return {
        ready: false,
        inventory: null,
        items: {},
        categories: {},
        categorySelections: [{
          catId: null,
          items: [{
            id: null,
            itemId: null
          }]
        }],
        data: {
          id: null,
          items: [],
          requirements: {}
        }
      }
    },

    async mounted() {
      this.$store.state.pageTitleTranslationKey = "inventory.order_requirements";
      this.$store.state.pageIcon = "/icon/menu.svg";

      this.$store.commit('showSpinner', true);
      this.inventory = await this.$store.getters.getContextInventory;
      Promise
        .all([
          Core.request("GET", `/api/inventory/${this.inventory.id}/order_requirements`),
          Core.request("GET", `/api/inventory/${this.inventory.id}/categories`),
          Core.request("GET", `/api/inventory/${this.inventory.id}/items`),
          Core.request("GET", `/api/inventory/${this.inventory.id}/item_to_categories`)
        ])
        .then(([orderRequirements, categories, items, itemToCategories]) => {
          if (orderRequirements.length > 0) {
            let requirements = orderRequirements[0];
            this.data = requirements;
          }

          for (let category of categories) {
            this.categories[category.id] = category;
          }
          for (let item of items) {
            this.items[item.id] = item;
          }
          this.categorySelections = categories
            .map(category => ({
              catId: category.id,
              items: itemToCategories
                .filter(itc => itc.category === category.id && !this.isItemDeleted(itc.item))
                .map(itc => ({
                  id: itc.id,
                  itemId: itc.item
                }))
            }));
          this.ready = true;
        })
        .finally(() => {
          this.$store.commit('showSpinner', false);
          if (this.$store.getters.isBranchContextInventory) {
            window.lockFields(this.$store.getters.getOverloadableFields);
          } else if (!this.$store.getters.loggedUserCanModifyInventory) {
            window.lockFields();
          }
        });
    },

    computed: {
    },

    methods: {
      isItemDeleted(id) {
        return !this.items[id];
      },

      getItemName(id) {
        return this.$to(this.items[id].name);
      },

      getCategoryName(id) {
        return this.$to(this.categories[id].name);
      },

      save() {
        let method = this.data.id ? "PUT" : "POST";
        let url = this.data.id
          ? `/api/inventory/${this.inventory.id}/order_requirements/${this.data.id}`
          : `/api/inventory/${this.inventory.id}/order_requirements`;

        this.$store.commit('showSpinner', true);
        Core.request(method, url, this.data)
          .then(x => {
            this.data.id = x.id;
          })
          .finally(() => {
            toast(this.$t("success"), "success");
            this.$store.commit('showSpinner', false);
          })
          .catch((e) => {
            toast(this.$t("error.no_server"), "error");
            console.log("error", e);
          })
      }
    }
  }
</script>

<style lang="scss" scoped>
    .item-checkbox-line {
        margin-left: 30px;

      &:not(:last-child) {
        margin-bottom: 5px;
      }
    }
    .readonly .item-checkbox-line {
        pointer-events: none;
    }
</style>